import { render, staticRenderFns } from "./EmptyTicketingTab.vue?vue&type=template&id=6c5b4c7b&scoped=true"
import script from "./EmptyTicketingTab.vue?vue&type=script&lang=js"
export * from "./EmptyTicketingTab.vue?vue&type=script&lang=js"
import style0 from "./EmptyTicketingTab.vue?vue&type=style&index=0&id=6c5b4c7b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5b4c7b",
  null
  
)

export default component.exports